<h2>Business Admin</h2>
<app-basic-action-table
  dataName="Business"
  [columns]="columns"
  [actions]="actions"
  [filterComparator]="filterComparator"
  endpoint="businessadmin"
></app-basic-action-table>
